<!-- 电子数据保全验证 -->
<template>
  <div class="region" @keydown.enter="search">
    <div class="certificate" v-show="isSearch">
      <div class="certificate-item2"  style="margin-top: -10px;">
        <p class="item-title">{{info.title_1}}</p>
        <div class="item-file">
          <textarea
            type="text"
            disabled="disabled"
            style="background:#fff"
            v-model.trim="formInfo.fileHash"
            :style="{'padding-top':formInfo.fileHash?'0px':'10px'}"
            :placeholder="info.holder_1"
          ></textarea>
          <div class="file">
            <div id="picker">
              <!-- <el-upload
                class="upload-demo"
                action="https://www.mocky.io/v2/5185415ba171ea3a00704eed/posts/"
                :before-upload="beforeFileQueued"
                :on-success="fileSuccess"
                :multiple="false"
              >
                <el-button size="small" type="primary">
                  <span>+</span>
                  {{info.operate}}
                </el-button>
              </el-upload> -->

                  <span>+</span>
                  {{info.operate}}
            </div>

            <input type="file" class="fileEle" id="file" value="选择文件" @change="selectFile($event)">
          </div>
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.fileHash.isError">{{tipsInfo.fileHash.msg}}</div>
        </div>
      </div>
      <div class="certificate-item enclosure_box">
        <!-- <p class="item-title">{{info.title_2}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.code"
            @blur="verificationCode"
            :placeholder="info.holder_2"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.code.isError">{{tipsInfo.code.msg}}</div>
        </div> -->
        <el-checkbox class="enclosure"  v-model="checkEnclosure">{{info.enclosure_title}}</el-checkbox>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_2}}</p>
        <div class="item-input">
          <input
            type="text"
            v-model.trim="formInfo.code"
            @blur="verificationCode"
            :placeholder="info.holder_2"
          />
        </div>
        <div class="item-tips">
          <div v-if="tipsInfo.code.isError">{{tipsInfo.code.msg}}</div>
        </div>
      </div>
      <div class="certificate-item">
        <p class="item-title">{{info.title_vCode}}</p>
        <div class="item-vcode">
          <input
            type="text"
            v-model.trim="formInfo.vcode"
            @blur="verificationVcode"
            :placeholder="info.holder_vCode"
          />
          <img :src="vcodeUrl?vcodeUrl:''" alt @click="getVcode" />
          <span @click="getVcode">{{info.change_vCode}}</span>
        </div>
        <div class="item-tips" v-if="tipsInfo.vcode.isError">
          <div v-if="tipsInfo.vcode.isError">{{tipsInfo.vcode.msg}}</div>
        </div>  
      </div>
      <div class="certificate-item">
        <p class="item-reminder">{{info.reminder}}</p>
      </div>
      <div class="certificate-operate" >
        <button @click="search" v-html="info.search" :disabled="!success" :class="success?'disable':'pendding'"></button>
      </div>
    </div>
    <div class="error" v-show="isSearchError">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.errTips}}</div>
      </div>
      <div class="error-operate">
        <button @click="continueSearch">{{info.continue}}</button>
      </div>
    </div>
    <loading v-if="$store.state.showLoading"></loading>
    <!-- 删除提示 -->
    <div class="error" v-show="deleteError">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.deleteTips}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
    <!-- 过期提示 -->
    <div class="error" v-show="expireEroor">
      <div class="error-tip">
        <i>
          <img src="~img/validateQuery/fail_icon.png" alt />
        </i>
        <div>{{info.expireTips}}</div>
      </div>
      <div class="error-operate" style="text-align: center;">
        <button @click="continueSearch" >{{info.continue}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import rule from "@/lib/const";
import Loading from "../common/Loading";
import $qs from "qs";
import $ from "jquery";
import WebUploader from "webuploader";
import { vaildateIDCard,validateMobile, ivaildateBLCard,verificationpPhone,verificationpMailbox } from "@/utils/validate";
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      isSearch: true, //是否查询
      isUser:false,
      success:true,
      isUpload:false,
      filename:"",
      formInfo: {
        fileName: "",
        fileSize: "",
        fileHash: "",
        code: "",
        vcode: ""
      },
      fileName: "",
      fileSize: "",
      fileHash: "",//文件哈希
      tipsInfo: {
        fileHash: {
          isError: false,
          msg: this.info.err
        },
        code: {
          isError: false,
          msg: this.info.err
        },
        vcode: {
          isError: false,
          msg: this.info.err
        }
      },
      vcodeUrl: "",
      checkEnclosure:false,
      isSearchError:false,
      expireEroor:false,
      deleteError:false,
    };
  },
  props: ["info"],
  computed: {},
  components:{
    Loading,
  },
  methods: {
    //上传文件之前
    beforeFileQueued(e) {
      // console.log("上传之前")
      let file=e.target.files[0];
      let fileType=file.name.slice(file.name.lastIndexOf(".")+1)
      var typeItem = { isNext: false, type: "" };
      if (this.RIGHTSFILETYPES.audio.includes(fileType)) {
        typeItem.isNext = true;
        typeItem.type = "audio";
      }
      if (this.RIGHTSFILETYPES.doc.includes(fileType)) {
        typeItem.isNext = true;
        typeItem.type = "doc";
      }
      if (this.RIGHTSFILETYPES.image.includes(fileType)) {
        typeItem.isNext = true;
        typeItem.type = "image";
      }
      if (this.RIGHTSFILETYPES.video.includes(fileType)) {
        typeItem.isNext = true;
        typeItem.type = "video";
      }
      if (typeItem.isNext) {
        if (typeItem.type == "doc" || typeItem.type == "image") {
          if (file.size > 52428800) {
            this.tipsInfo.number.isError = true;
            this.tipsInfo.number.msg = this.info.err_6;
            return false;
          }
        }
        if (typeItem.type == "audio" || typeItem.type == "video") {
          if (file.size > 209715200) {
            this.tipsInfo.number.isError = true;
            this.tipsInfo.number.msg = this.info.err_6;
            return false;
          }
        }
        this.formInfo.number = file.name;
        this.tipsInfo.number.isError = false;
        this.fileSuccess(file)
      } else {
        this.formInfo.number = "";
        this.tipsInfo.number.isError = true;
        this.tipsInfo.number.msg = this.info.err;
        return false;
      }
    },
    //文件提取Hash
    selectFile(event){
      var file = event.target.files[0];
      if(!file) {
        return;
      }
      var _this=this;
      this.fileName = file.name;
      this.fileSize = file.size;
      var checkFile = {};
      checkFile.fileName = file.name;
      checkFile.fileSize = file.size;
      var formInfo = this.formInfo;

      //边读取边算HASH
      var reader = new FileReader();
      _this.$store.commit('showLoading', true);
      var blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice;
      // 指定文件分块大小(10M)
      var chunkSize = 10 * 1024 * 1024;
      // 计算文件分块总数
      var chunks = Math.ceil(file.size / chunkSize);
      // 指定当前块指针
      var currentChunk = 0;
      // 计算开始读取的位置
      var start = currentChunk * chunkSize;
      // 计算结束读取的位置
      var end = start + chunkSize >= file.size ? file.size : start + chunkSize;

      var startTime = new Date();
      //var sha256Hasher = CryptoJS.algo.SHA256.create();
      var sha512Hasher = CryptoJS.algo.SHA512.create();
      reader.readAsArrayBuffer(blobSlice.call(file, start, end));
      reader.onload = function (evt) {
        if (evt.target.readyState == FileReader.DONE) {
          var arrayBuffer = evt.target.result;
          var i8a = new Uint8Array(arrayBuffer);
          var a = [];
          for (var i = 0; i < i8a.length; i += 4) {
            a.push(i8a[i] << 24 | i8a[i + 1] << 16 | i8a[i + 2] << 8 | i8a[i + 3]);
          }
          var tmpWordArray = CryptoJS.lib.WordArray.create(a, i8a.length);
          sha512Hasher.update(tmpWordArray);
          currentChunk += 1;
          
          tmpWordArray = null;
          // 判断文件是否都已经读取完
          if (currentChunk < chunks) {
              // 计算开始读取的位置
              var start = currentChunk * chunkSize;
              // 计算结束读取的位置
              var end = start + chunkSize >= file.size ? file.size : start + chunkSize;
              reader.readAsArrayBuffer(blobSlice.call(file, start, end));
          } else {
              // 文件流读取完成后，产生最终hash
            formInfo.fileHash = sha512Hasher.finalize().toString();
            //用于验证
            formInfo.fileName = checkFile.fileName;
            formInfo.fileSize = checkFile.fileSize;

            file = null;
            sha512Hasher = null;
            blobSlice = null;
            reader = null;
            var endTime = new Date();
            _this.$store.commit('showLoading', false);
            // console.log("读取文件时间：" + (endTime - startTime) + "ms")
          }
        }
      }

      // 执行完所有操作后手动清除input中已选文件
      event.target.value = ''
    },
    // 验证文件hash
    verificationFileHash() {
      if (this.formInfo.fileHash) {
         var exp =  /^[a-zA-Z0-9]{128}$/
        if (exp.test(this.formInfo.fileHash)) {
          this.tipsInfo.fileHash.isError = false;
          return true;
        } else {
          this.tipsInfo.fileHash.isError = true;
          this.tipsInfo.fileHash.msg = this.info.err;
          return false;
        }
      } else {
        this.tipsInfo.fileHash.isError = true;
        this.tipsInfo.fileHash.msg = this.info.void_1;
        return false;
      }
    },
    // 验证手机号码
    verificationCode() {
      let val = this.formInfo.code;
      if (val) {
        if(verificationpPhone(val) || verificationpMailbox(val)){
           this.tipsInfo.code.isError = false;
           this.isSerachCode(val)
           return true
        }else{
           this.tipsInfo.code.isError = true;
           this.tipsInfo.code.msg = this.info.err_5;
           return false; 
        }
      } else {
        this.tipsInfo.code.isError = true;
        this.tipsInfo.code.msg = this.info.void_2;
        return false;
      }
    },
    //查询账号是否存在
    isSerachCode(val)  {
      this.$ajax.get("/webapi/common/checkAccount",{params:{account: val}}).then(res=>{
          if(res.data.code==200){
             if(res.data.extraData.code==3007){
                 this.tipsInfo.code.isError = true;
                 this.tipsInfo.code.msg = this.info.err_2;
             }else if(res.data.extraData.code==3001){
                this.isUser=true;
                  this.tipsInfo.code.isError = false;
             }
          }
      })  
    },
   

    // 验证验证码
    verificationVcode() {
    if (this.formInfo.vcode) {
        if (/^([a-z]|[A-Z]|[0-9]){4}$/.test(this.formInfo.vcode)) {
          this.tipsInfo.vcode.isError = false;
          return true;
        } else {
          this.tipsInfo.vcode.isError = true;
          this.tipsInfo.vcode.msg = this.info.err_5;
          return false;
        }
      } else {
        this.tipsInfo.vcode.isError = true;
        this.tipsInfo.vcode.msg = this.info.void_vCode;
        return false;
      }
    },
    //查询
    search() {
      // this.isSearch = false;
      // this.$emit("noReal", true);
      if (
        this.verificationFileHash() &&
        this.isUser &&
        this.verificationVcode() && this.fileName == this.formInfo.fileName && this.fileSize == this.formInfo.fileSize
      ) {
        this.success=false;
        this.$ajax.get('/webapi/validateQuery/filePreservationVerification', {params:{
          fileHash: this.formInfo.fileHash,
          loginAccount: this.formInfo.code,
          vcode: this.formInfo.vcode,
          type:this.checkEnclosure?2:1,
        }}).then((res) => {
          if (res.data.code === 200) {
            this.success=true;
            if(res.data.extraData.list.length){
              window.sessionStorage.setItem("a_"+res.data.extraData.list[0].certificateNumber,JSON.stringify(res.data.extraData.list))
               this.$router.push({
                    path: "validateShow",
                    query: {
                      currentType: 1,
                      uid:res.data.extraData.list.length?res.data.extraData.list[0].userId:'',
                      type:res.data.extraData.list.length?res.data.extraData.list[0].type:'',
                      // vcode:this.formInfo.vcode, 
                      // loginAccount: this.formInfo.code,
                      partnerId:res.data.extraData.list.length?res.data.extraData.list[0].partnerId:'',
                      certificateNumber:"a_"+res.data.extraData.list[0].certificateNumber,
                      checkEnclosure:this.checkEnclosure
                    }
                })
            }else{
                 this.isSearch = false;
                 this.isSearchError=true;
            }
          // Vcode Error
          } else if (res.data.code === 1005) {
            // ZX-BWX-0720180423911760
             this.tipsInfo.vcode.msg = this.info.err_3;
             this.tipsInfo.vcode.isError = true;
            this.success=true;
            this.getVcode()
          } else if (res.data.code === 414) {
            this.success=true;
            this.$emit('noReal', true)
            this.getVcode()
          } else {
            this.success=true;
            this.isSearch = false;
            this.isSearchError=true;
            this.searchState = false
            this.getVcode()
          }
        })
      } else {
        this.verificationFileHash();
        this.verificationCode();
        this.verificationVcode();
        this.getVcode()
      }
    },
    //更换验证码
    getVcode() {
      setTimeout(()=>{
         $(".webuploader-pick").next().css({'width':'100px','height':'40px','opacity':'0'})
      },100)
      this.$ajax
        .get("/webapi/common/getCode")
        .then(res => {
          if (res.data.code == 200) {
            //  "data:image/png;base64," +
            this.vcodeUrl ='data:image/png;base64,'+ res.data.extraData.code;
          }
        })
    },
    //继续查询
    continueSearch() {
      this.formInfo.fileName = "";
      this.formInfo.fileSize = "";
      this.formInfo.fileHash = "";
      this.formInfo.code = "";
      this.formInfo.vcode = "";
      document.getElementById('file').value = null;
      this.tipsInfo.fileHash.isError = false;
      this.tipsInfo.code.isError = false;
      this.tipsInfo.vcode.isError = false;
      this.isSearch = true;
      this.isSearchError=false;
      this.expireEroor=false;
      this.deleteError=false;
       this.getVcode()
    },
     //上传文件
    fileInit () {
      this.uploader = WebUploader.create({
        swf: "http://cdn.staticfile.org/webuploader/0.1.0/Uploader.swf",
        server:this.$GlobalConfig.webApiServerTest +'/webapi/validateQuery/ObtainFileHash', // 文件接收服务端
        pick: {
          id: "#picker",
          multiple: false,
        },
        compress: false,
        duplicate: true
      })
      var that = this
      this.uploader.on('beforeFileQueued', function(file) {
        // console.log(file)
        that.uploader.reset()
        var typeItem = { isNext: false, type: '' }
        // that.checkFile.fileName = ''
        if (file.size !== 0) {
           let fileType = file.type.slice(file.type.indexOf("/") + 1);
          //  console.log(fileType,"文件类型")
            if (that.RIGHTSFILETYPES.audio.includes(fileType)) {
              typeItem.isNext = true;
              typeItem.type = "audio";
            }
            if (that.RIGHTSFILETYPES.doc.includes(fileType)) {
              typeItem.isNext = true;
              typeItem.type = "doc";
            }
            if (that.RIGHTSFILETYPES.image.includes(fileType)) {
              typeItem.isNext = true;
              // console.log("image",fileType)
              typeItem.type = "image";
            }
            if (that.RIGHTSFILETYPES.video.includes(fileType)) {
              // console.log("image",fileType)
              typeItem.isNext = true;
              typeItem.type = "video";
            }
        }
        if (typeItem.isNext) {
          if (typeItem.type == 'doc' || typeItem.type == 'image') {
            if (file.size > 52428800) {
               that.tipsInfo.number.isError = true
               that.tipsInfo.number.msg = that.info.err;
              return false
            }
          }
          if (typeItem.type == 'audio' || typeItem.type == 'video') {
            if (file.size > 209715200) {
            
               that.tipsInfo.number.isError = true
              that.tipsInfo.number.msg = that.info.err;
              return false
            }
          }
           that.tipsInfo.number.isError = false
           that.formInfo.number = file.name
          //  console.log(that.formInfo.number,typeItem.type)
        } else {
           that.tipsInfo.number.isError = true
             that.tipsInfo.number.msg = that.info.err;
          return false
        }
      })
      // uploader success
      this.uploader.on('uploadSuccess', function (file, response) {
        // console.log(file,"上传文件成功")
        that.fileHash = response.extraData.fileHash
      })

      this.uploader.on('uploadError', function(file) {
      //  console.log("上传出错")
      });
    },
  },
  mounted() {
    // this.fileInit();
    this.getVcode();
    this.RIGHTSFILETYPES = rule.RIGHTSFILETYPES;
    
  }
  ,watch:{
			'$route' () {
				let pos = this.$router.history.current.path.indexOf("cn");
				if (pos) {
             this.tipsInfo.code.msg = this.info.void_2;
             this.tipsInfo.vcode.msg = this.info.err_3;
             this.tipsInfo.fileHash.msg = this.info.void_1;
				}
			}
		}
  
};
</script>
<style lang="scss" scoped>
.region {
  width: 100%;
  .certificate {
    width: 736px;
    padding-top: 40px;
    margin: 0 auto;
    &-item {
      .item {
        &-title {
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          color: #fff;
        }
        &-input {
          padding-top: 10px;
          input {
            outline: none;
            width: 100%;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            font-size: 12px;
          }
        }
        &-tips {
          height: 28px;
          div {
            height: 28px;
            line-height: 28px;
            padding-left: 14px;
            font-size: 12px;
            color: #d0444f;
          }
        }
        &-vcode {
          padding-top: 10px;
          input {
            outline: none;
            width: 198px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            font-size: 12px;
          }
          img {
            width: 90px;
            height: 40px;
            margin-left: 15px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            color: #bfbfc2;
            font-size: 14px;
            cursor: pointer;
          }
        }
        &-file {
          overflow: hidden;
          padding-top: 10px;
          input {
            float: left;
            outline: none;
            width: 443px;
            height: 40px;
            font-size: 12px;
            padding-right: 15px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .file {
              .webuploader-pick {
                  background-color:#ffffff;
              }
            div{
              overflow:visible ;
              height: 30px !important;
            }
            .el-button--primary {
              border: 0;
              background: none;
              color: #434343;
              font-size: 14px;
            }
            position: relative;

            background: #cacaca;
            color: #434343;
            height: 40px;
            line-height: 40px;
            width: 146px;
            float: left;
            font-size: 14px;
            padding-left: 0;
            text-align: center;
            cursor: pointer;
            &:hover {
              background: #b4b4b4;
            }
            input {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 1;
            }
          }
        }
        &-reminder {
          color: #d0444f;
          font-size: 14px;
          margin-top: 5px;
        }
      }
    }

    &-item2 {
      .item {
        &-title {
          height: 16px;
          line-height: 16px;
          font-size: 14px;
          color: #fff;
        }
        &-input {
          padding-top: 10px;
          input {
            outline: none;
            width: 100%;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            font-size: 12px;
          }
        }
        &-tips {
          height: 28px;
          div {
            height: 28px;
            line-height: 28px;
            padding-left: 14px;
            font-size: 12px;
            color: #d0444f;
          }
        }
        &-vcode {
          padding-top: 10px;
          input {
            outline: none;
            width: 198px;
            height: 40px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            font-size: 12px;
          }
          img {
            width: 90px;
            height: 40px;
            margin-left: 15px;
            vertical-align: middle;
          }
          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            color: #bfbfc2;
            font-size: 14px;
            cursor: pointer;
          }
        }
        &-file {
          overflow: hidden;
          padding-top: 10px;
          textarea {
            float: left;
            outline: none;
            width: 590px;
            height: 40px;
            font-size: 12px;
            padding-right: 15px;
            padding-left: 14px;
            border: 1px solid #f1f1f1;
            overflow: hidden;
            word-wrap:break-word;
            word-break:break-all;
            resize: none;
            font-family: 微软雅黑;
          }
          .file {
              .webuploader-pick {
                  background-color:#ffffff;
              }
            div{
              overflow:visible ;
              height: 30px !important;
            }
            .el-button--primary {
              border: 0;
              background: none;
              color: #434343;
              font-size: 14px;
            }
            position: relative;
            background: #cacaca;
            color: #434343;
            height: 40px;
            line-height: 40px;
            width: 146px;
            float: right;
            font-size: 14px;
            padding-left: 0;
            text-align: center;
            &:hover {
              background: #1C6FED;
              color: #fff;
            }
            input {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 1;
            }
            .fileEle{
              position: absolute;
              top: 0px;
              right: 0px;
              height: 100%;
              width: 146px;
              opacity: 0;
            }
          }
        }
        &-reminder {
          color: #d0444f;
          font-size: 14px;
          margin-top: 5px;
        }
      }
    }


    &-operate {
       text-align: center;
       margin-top: 23px;
      button {
        height: 46px;
        line-height: 46px;
        width: 284px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 16px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
    }
    .disable{
      background-color: #c62e3f;
    }
    .pendding{
      background-color: #ccc;
      color: #fff;
    }
      .pendding:hover{
        background: #d2d2d2 !important;
        color: #fff;
      }
  }
  .error {
    padding-top: 90px;
    &-tip {
      position: relative;
      width: 592px;
      height: 169px;
      margin: 0 auto;
      background: url("~img/validateQuery/zjcx_fail_bg_img.png");
      color: #fff;
      i {
        position: absolute;
        top: 61px;
        left: 50%;
        transform: translateX(-50%);
        width: 23px;
        height: 23px;
      }
      div {
        position: relative;
        top: 59%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 550px;
        text-align: center;
        word-wrap: break-word;
        word-break: normal;
        font-size: 14px;
        text-align: center;
      }
    }
    &-operate {
      margin-top: 70px;
      text-align: center;
      button {
        height: 46px;
        line-height: 46px;
        width: 284px;
        background-color: #c62e3f;
        color: #fff;
        font-size: 16px;
        &:hover {
          background-color: #ea4b5d;
        }
      }
    }
  }
  .enclosure_box{
    margin-bottom:20px;
   /deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
         background-color: #C62E3F;
    border-color: #C62E3F;
   }
   /deep/.el-checkbox__input.is-focus .el-checkbox__inner{
     border-color:#C62E3F; 
   }
   /deep/.el-checkbox__inner:hover{
     border-color: #DCDFE6;
   }
   /deep/.el-checkbox__label{
     padding-left: 6px;
   }
   /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
     color: #ffffff;
   }
   /deep/.el-checkbox{
     color: #ffffff;
   }
}
}
</style>
